import React from 'react';
import { Page, List, Icon, Card } from 'react-onsenui';
import './list.css'
import Anaf from './anaf/anaf'


export default (props) => {
    return (
        <Page className="pageMenuList">
            {
                props.data.desc_ro || props.data.desc_eng ?
                    <div style={{ padding: 10, display: 'flex', alignItems: "center" }}>
                        <p style={{ margin: 0, display: 'flex', alignItems: 'center' }}>
                            <Icon
                                size={{ default: 18, material: 20 }}
                                icon={{ default: 'ion-navicon', material: 'md-info' }}
                                style={{ opacity: .8, color: "#4F1308" }}
                            />
                            <span style={{ marginLeft: 10, fontWeight: 600, fontSize: 14 }}>
                                {props.data.desc_ro}
                                {
                                    props.data.desc_eng ?
                                        " / " + props.data.desc_eng
                                        : null
                                }
                            </span>
                        </p>
                    </div>
                    : null
            }
            <List
                className="menuList"
                dataSource={props.data.prod}
                renderRow={(row, idx) => (
                    <Card key={idx} className="menuItem">
                        <div>
                            {
                                row.name_ro ?
                                    <p className="menuItemTitle">
                                        {row.name_ro}
                                        {
                                            row.pers_ro ?
                                                <span className="pers">
                                                    {row.pers_ro}
                                                </span>
                                                :
                                                null
                                        }
                                    </p>
                                    : null
                            }

                            {
                                row.desc_ro ?
                                    <p className="menuItemDesc">
                                        {row.desc_ro}
                                    </p>
                                    : null
                            }
                            {
                                row.name_eng ?
                                    <p className="menuItemTitle eng">
                                        {row.name_eng}
                                        {
                                            row.pers_eng ?
                                                <span className="pers">
                                                    {row.pers_eng}
                                                </span>
                                                :
                                                null
                                        }
                                    </p>
                                    : null
                            }
                            {
                                row.desc_eng ?
                                    <p className="menuItemDesc eng">
                                        {row.desc_eng}
                                    </p>
                                    : null
                            }
                            {
                                row.alergeni ?
                                    <p className="menuItemAlerg">
                                        Alegeni : {row.alergeni}
                                    </p>
                                    :
                                    null
                            }
                            <div className="menuItemPrice">
                                <span style={{ marginRight: 10, color: "#000", fontWeight: "normal" }}>
                                    {row.gramaj}
                                </span>
                                <span>
                                    {
                                        row.price ?
                                            row.price +" RON"
                                        :null
                                    }
                                </span>
                            </div>
                        </div>
                    </Card>
                )}
            />
            <div className="footer"> 
                  <Anaf/>                     
            </div>
        </Page>
    );
}
